module.exports = __webpack_public_path__ + "static/voorlater-11-1454fa7fb8ead66b325ef2bf121d01ab.png";